import i18n from 'i18next';
import viTranslate from './vi/tran.json';
import enTranslate from './en/tran.json';
import { initReactI18next } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/vi'; 

export const resources = {
  en: {
    translation: enTranslate,
  },
  vi: {
    translation: viTranslate,
  },
} as const;

i18n.use(initReactI18next).init({
  lng: 'vi',
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  resources,
});
moment.locale('vi');
moment.updateLocale('vi', {
  months: [
    'Tháng 1',
    'Tháng 2',
    'Tháng 3',
    'Tháng 4',
    'Tháng 5',
    'Tháng 6',
    'Tháng 7',
    'Tháng 8',
    'Tháng 9',
    'Tháng 10',
    'Tháng 11',
    'Tháng 12',
  ],
  weekdays: [
    'Chủ Nhật',
    'Thứ Hai',
    'Thứ Ba',
    'Thứ Tư',
    'Thứ Năm',
    'Thứ Sáu',
    'Thứ Bảy',
  ],
});